<template>
    <div class="block-editor youtube-update-comment-status">
        <section>
            <div class="title">{{ $t('auto.youTubeUpdateCommentStatusCommentId') }}</div>
            <TiptapEditor placeholder="YouTube Comment ID" :show-attributes="true" v-model="clone.commentId" automation-mode />
            <small>{{ $t('auto.youTubeUpdateCommentStatusDurumuGNcellenecekYorumunIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.youTubeUpdateCommentStatusYeniDurum') }}</div>
            <a-select v-model="clone.status" class="classic-select" :placeholder="$t('auto.youTubeUpdateCommentStatusDurumSeIniz')">
                <a-select-option value="new">{{ $t('auto.youTubeUpdateCommentStatusYeniNew') }}</a-select-option>
                <a-select-option value="replied">{{ $t('auto.youTubeUpdateCommentStatusYanTlandReplied') }}</a-select-option>
                <a-select-option value="resolved">{{ $t('auto.youTubeUpdateCommentStatusZLdResolved') }}</a-select-option>
            </a-select>
        </section>
        <section>
            <div class="title">{{ $t('auto.youTubeUpdateCommentStatusAtanacakTemsilciOpsiyonel') }}</div>
            <a-select v-model="clone.assigneeId" class="classic-select" :placeholder="$t('auto.youTubeUpdateCommentStatusTemsilciSeIniz')" allow-clear>
                <a-select-option v-for="user in users" :key="user._id" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
            <small>{{ $t('auto.youTubeUpdateCommentStatusYorumuBirTemsilciyeAtayabilirsiniz') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import { mapState } from "vuex";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "YouTubeUpdateCommentStatus",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                commentId: "",
                status: "new",
                assigneeId: null,
                ...this.value
            }),
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.youtube-update-comment-status {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
    }
}
</style>
